<template>
  <div class="wrapper df jcc aic">
    <button
      v-on:click="goToSalesPage()"
      class="back-button button-small nexa-font-bold ttc"
    >
      back
    </button>
    <div
      class="login-register df fdr jcc aic"
      v-bind:class="{ fdrr: mode == 'login' }"
    >
      <div class="landing-logo f2 df fdc jcc aic">
        <img
          src="/images/hplogo-full.png"
          alt=""
          class="hourprice-logo"
        />
      </div>
      <div class="landing-login-register f3 df jcc aic">
        <Login
          v-if="mode == 'login'"
          v-bind:landingEmail="landingEmail"
          v-on:setLandingEmail="setLandingEmail"
        />
        <Register
          v-else-if="mode == 'register'"
          v-bind:landingEmail="landingEmail"
          v-on:setLandingEmail="setLandingEmail"
        />
        <ResetPassword
          v-else-if="mode == 'resetPassword'"
          v-bind:landingEmail="landingEmail"
          v-on:setLandingEmail="setLandingEmail"
        />
        <ForgotPassword
          v-else-if="mode == 'forgotPassword'"
          v-bind:landingEmail="landingEmail"
          v-on:setLandingEmail="setLandingEmail"
        />
        <NotFound v-else-if="mode == 'notFound'" />
        <Forbidden v-else-if="mode == 'forbidden'" />
      </div>
    </div>
  </div>
</template>

<script>
import Login from "../components/auth/Login";
import Register from "../components/auth/Register";
import ResetPassword from "../components/auth/ResetPassword";
import ForgotPassword from "../components/auth/ForgotPassword";
import NotFound from "../components/auth/NotFound";
import Forbidden from "../components/auth/Forbidden";
import router from "../router";

export default {
  name: "Landing",
  data() {
    return {
      landingEmail: ""
    };
  },
  props: ["mode"],
  components: {
    NotFound,
    Forbidden,
    Login,
    Register,
    ResetPassword,
    ForgotPassword
  },
  methods: {
    setLandingEmail(data) {
      if (data.landingEmail) {
        this.landingEmail = data.landingEmail;
      }
    },
    goToSalesPage() {
      window.open("http://www.hourprice.com", "_self");
    }
  },
  computed: {},
  created() {
    console.log("* Loaded landing page");
    console.log("* Landing page mode:", this.mode);
  }
};
</script>

<style scoped lang="scss">
//
// Wrapper
//
.wrapper {
  width: 100%;
  min-height: 100vh;
  background-image: url("/images/landing-background.jpg");
  background-size: cover;

  align-items: center;

  // Responsive Style
  // @media max-width: 768px
  @media (max-width: 768px) {
    // padding-left: 40px;
    // padding-right: 40px;
  }
}

//
// Login Register
//
.login-register {
  width: 665px;
  height: 430px;
  border-radius: 8px;
  box-shadow: 0 2px 40px 0 rgba(0, 0, 0, 0.29);

  & > div:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  & > div:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  // Responsive Style
  // @media max-width: 768px
  @media (max-width: 768px) {
    display: block;
    width: calc(100% - 40px);
    // width: 100%;
    height: auto;
    margin-left: 40px;
    margin-right: 40px;

    > div {
      height: auto;
      &:first-child {
        padding: 20px 40px;
        border-radius: 4px 4px 0px 0px !important;
      }
      &:last-child {
        padding: 20px 40px 40px;
        border-radius: 0px 0px 4px 4px !important;
      }
    }
  }
}

.login-register.fdrr {
  & > div:first-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  & > div:last-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
}

.landing-logo {
  height: 100%;
  /*border-radius: 8px 0 0 8px;*/
  background-color: #313131;
  /*background: linear-gradient(0deg, #0764BB 0%, #0874D8 100%);*/
}

.landing-login-register {
  height: 100%;
  /*border-radius: 0 8px 8px 0;*/
  background-color: #ffffff;
}

.hourprice-logo {
  width: 150px;
  height: 150px;
  object-fit: contain;
  object-position: center;
}

//
// Back Button
//
.back-button {
  color: white;
  position: absolute;
  top: 20px;
  left: 30px;
  background-color: #5558ff;
  width: 80px;
  border: none;
  cursor: pointer;

  // Responsive Style
  // @media max-width: 768px
  @media (max-width: 768px) {
    left: 40px;
  }

  // Responsive Style
  // @media max-width: 420px
  @media (max-width: 420px) {
    left: 20px;
  }
}
</style>
